registerGlobal('ImageUtils');


ImageUtils.loadImage = function(arg, _url, callback) {
    var url = UTF8ToString(_url);
    var canvasID = 'hiddenCanvas';
    var canvas = document.getElementById(canvasID);
    if (!canvas) {
        throw "Canvas with id " + canvasID + " doesn't exists!";
    }
    var ctx = canvas.getContext('2d');

    var imageObj = new Image();
    imageObj.onload = function() {
        ctx.drawImage(this, 0, 0);
        var width = this.width;
        var height = this.height;
        var byteArray = ctx.getImageData(0, 0, width, height).data;
        var size = byteArray.length;

        var buffer = _malloc(size);
        HEAPU8.set(byteArray, buffer);
        if (callback) dynCall('viiiii', callback, [arg, width, height, buffer, size]);
    };

    imageObj.onerror = function() {
        if (callback) dynCall('viiiii', callback, [arg, 0, 0, 0, 0]);
    };

    imageObj.crossOrigin = 'anonymous';
    imageObj.src = url;
}



//////////////////
// WEBPACK FOOTER
// /src/claw/sdk/src/claw/graphics/emscripten/Application.imageutils.js
// module id = 17
// module chunks = 0